export default {
  path: '/lazada',
  component: () => import('@/views/lazada/index.vue'),
  children: [
    {
      path: 'products',
      name: 'LazadaProductsList',
      component: () => import('@/views/lazada/pages/ProductsList.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'products/create',
      name: 'LazadaCreateProduct',
      component: () => import('@/views/lazada/pages/ProductForm.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'products/:productId',
      name: 'LazadaEditProduct',
      component: () => import('@/views/lazada/pages/ProductForm.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'management',
          'marketing',
          'inventory_and_costing',
          'online_admin',
          'support'
        ]
      }
    },
    {
      path: 'request-log',
      name: 'LazadaRequestLog',
      component: () => import('@/views/lazada/pages/RequestLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'webhook-log',
      name: 'LazadaWebhookLog',
      component: () => import('@/views/lazada/pages/WebhookLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'token-log',
      name: 'LazadaTokenLog',
      component: () => import('@/views/lazada/pages/TokenLog.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'select-store',
      name: 'LazadaSelectStore',
      component: () => import('@/views/lazada/pages/SelectStore.vue'),
      meta: {
        layout: 'Blank'
      }
    },
    {
      path: 'authorized-shop',
      name: 'LazadaAuthorizedShop',
      component: () => import('@/views/lazada/pages/AuthorizedShop.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'order',
      name: 'LazadaOrderList',
      component: () => import('@/views/lazada/pages/OrderList.vue'),
      meta: {
        middleware: [
          'auth',
          'online_admin',
          'warehouse_manager',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'return-order',
      name: 'LazadaReturnOrder',
      component: () => import('@/views/lazada/pages/ReturnOrder.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    },
    {
      path: 'sync-order-error',
      name: 'LazadaSyncOrderError',
      component: () => import('@/views/lazada/pages/SyncOrderError.vue'),
      meta: {
        middleware: [
          'auth',
          'developer',
          'support'
        ]
      }
    }
  ]
}
